// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2234":"88e921e5","2506":"88e921e5","4827":"88e921e5","6377":"1077cc13","9629":"1077cc13"}[chunkId] + ".chunk.css";
};